/**
 * App 根元件：套上 Ionic 外殼、掛上路由。
 *
 * **沒有 AuthGate。**square-photo 全程在裝置端處理照片，不打任何 API，也就
 * 沒有身分可言——加登入閘門只會擋在使用者與工具之間。這是與 diet 刻意不同的一點，
 * 其餘外殼（Ionic 元件、路由、主題）兩個 app 一致。
 */

import { IonApp, IonRouterOutlet } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Redirect, Route } from 'react-router-dom';
import { AmbientBackground, ErrorBoundary } from '@shared/ui';
import { PhotoApp } from '@square-photo/components/photo-app';

export function App() {
  return (
    <IonApp>
      <AmbientBackground />

      {/*
        錯誤邊界包在路由外側：轉換流程的例外（Worker 崩潰、記憶體不足）若讓 React
        整棵樹卸載，使用者會看到全白畫面而不知道發生什麼事。
      */}
      <ErrorBoundary logTag="PhotoApp">
        <IonReactRouter>
          {/*
            **頁面轉場、返回手勢與 page stack 全部由 IonRouterOutlet 提供**，
            這也是選 `@ionic/react-router`（綁 react-router v5）而非其他 router 的
            唯一理由——它是接得上 Ionic 轉場的那一個。

            IonRouterOutlet 會自行檢視直屬子節點的 `path` 來決定推入／彈出哪個頁面，
            故子節點只能是 Route／Redirect，中間不可再包一層元件。
            每個 route 的元件本身必須是 IonPage，否則轉場沒有可動的容器。
          */}
          <IonRouterOutlet>
            <Route path="/" exact component={PhotoApp} />

            {/*
              未知路徑一律回首頁。包在 Route 裡而非裸寫 Redirect：裸的 Redirect
              沒有 path，IonRouterOutlet 比對不到，會在每次轉場時把它當成候選頁。
            */}
            <Route render={() => <Redirect to="/" />} />
          </IonRouterOutlet>
        </IonReactRouter>
      </ErrorBoundary>
    </IonApp>
  );
}
